interface LabelJSON {
  name: string;
  description: string;
}

class Label {
  public name: string;

  public description: string;

  /**
   * @param {LabelJSON} obj - dictionary object to parse
   * @return {HCLText.ts}
   */
  static build(obj: LabelJSON): Label {
    return new Label(obj.name, obj.description);
  }

  /**
   * @param {string} name
   * @param {string} description
   */
  constructor(name = '', description = '') {
    this.name = name || '';
    this.description = description || '';
  }

  /**
   * @return {string}
   */
  getName(): string {
    return this.name;
  }


  /**
   * @param {string} name
   */
  setName(name: string) {
    this.name = name;
  }


  /**
   * @return {string}
   */
  getDescription(): string {
    return this.description;
  }


  /**
   * @param {string} description
   */
  setDescription(description: string) {
    this.description = description;
  }


  /**
   * @return {LabelJSON} - dictionary object that represents this
   */
  toJSON(): LabelJSON {
    return ({
      name: this.name,
      description: this.description,
    });
  }

  clone(): Label {
    return Label.build(this.toJSON());
  }
}

export default Label;
export { Label, LabelJSON };
